module.exports = __webpack_public_path__ + "static/media/dr2.89409cb5.png";